export const purchaseProveFiles = "purchaseProve";
export const files = "files";


// WEBPACK FOOTER //
// ./src/components/File/FileAvailableCollections.js